const r = {
  gray: {
    50: "#FAFAFA",
    100: "#F1F1F1",
    200: "#E6E6E6",
    400: "#7F7F7F",
    500: "#757575",
    700: "#454545",
    900: "#242424"
  },
  red: {
    500: "#E21833",
    900: "#A90007"
  },
  blue: {
    500: "#2F7EDA"
  },
  green: {
    500: "#008000"
  },
  gold: {
    500: "#FFD200"
  }
}, e = {
  white: "#FFFFFF",
  black: "#000000"
}, g = {
  red: r.red[500],
  blue: r.blue[500],
  green: r.green[500],
  gold: r.gold[500],
  white: e.white,
  black: e.black,
  redDark: r.red[900],
  gray: {
    darker: r.gray[900],
    dark: r.gray[700],
    mediumAA: r.gray[500],
    medium: r.gray[400],
    light: r.gray[200],
    lighter: r.gray[100],
    lightest: r.gray[50]
  }
};
export {
  g as color
};
//# sourceMappingURL=color.js.map
